/* ============================================================
   CC- Küchenvorschau-Funnel — Upload-Seite Logik
   Erstellt von Claude Code (cc-)
   - Foto: Datei/Kamera + Vorschau + Drag&Drop + entfernen
   - Motiv-Picker: Drawer von rechts, Kachel-Auswahl, Suche
   - E-Mail aus URL (?email=) vorausgefüllt
   - Absenden: Foto -> Upload-Endpoint (POST), dann Danke-Seite ?motiv=
     (Endpoint leer = Demo, leitet ohne echten Upload weiter)
   ============================================================ */
(function () {
  var root = document.querySelector('.cc-up');
  if (!root) return;
  var uploadEndpoint = root.getAttribute('data-cc-upload-endpoint') || '';
  var dankeUrl = root.getAttribute('data-cc-danke-url') || '/pages/danke';
  var state = { file: null, previewUrl: null, motif: null, motifImg: null };

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return root.querySelectorAll(sel); };

  // Zentrales Klick-Tracking: GTM dataLayer + Meta Pixel (Custom Event)
  function ccTrack(event, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', event, data || {}); } catch (e) {}
  }

  // ---------- Weiche: „Foto jetzt hochladen" / „Erstmal umschauen" ----------
  var choice = $('[data-cc-choice]');
  var flow = $('[data-cc-flow]');
  var choiceUpload = $('[data-cc-choice-upload]');
  var choiceBrowse = $('[data-cc-choice-browse]');
  if (choiceUpload) {
    choiceUpload.addEventListener('click', function () {
      ccTrack('cc_up_choice_upload', { funnel_step: 'upload_choice' });
      if (choice) choice.classList.add('cc-up-hidden');
      if (flow) {
        flow.classList.remove('cc-up-hidden');
        try { flow.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }
    });
  }
  if (choiceBrowse) {
    // Link folgt automatisch (href="…kuechenrueckwaende") — Event synchron davor feuern
    choiceBrowse.addEventListener('click', function () {
      ccTrack('cc_up_choice_browse', { funnel_step: 'upload_choice' });
    });
  }

  // ---------- Foto ----------
  var fileInput = $('[data-cc-file]');
  var dropEmpty = $('[data-cc-drop-empty]');
  var dropFilled = $('[data-cc-drop-filled]');
  var previewImg = $('[data-cc-preview-img]');
  var dragover = $('[data-cc-dragover]');
  var drop = $('[data-cc-drop]');

  // Der gruene "E-Mail eingetragen"-Balken gehoert nur zum Weg Landing -> Upload.
  // Wer spaeter ueber den Mail-Link zurueckkommt, sah dieselbe Meldung ohne Kontext.
  // Die Landing setzt vor der Weiterleitung ein sessionStorage-Flag; nur dann zeigen.
  var mailnote = $('[data-cc-mailnote]');
  if (mailnote) {
    try {
      if (sessionStorage.getItem('cc_funnel_from_landing') === '1') {
        mailnote.classList.remove('cc-up-hidden');
        sessionStorage.removeItem('cc_funnel_from_landing');
      }
    } catch (e) {}
  }


  // Zeigt statt eines kaputten Bildes einen ehrlichen Hinweis. Betrifft vor allem HEIC/HEIF
  // vom iPhone: der Browser nimmt die Datei an (type = image/heic), kann sie aber nicht
  // darstellen — der Kunde sah nur ein leeres graues Feld (Alwin, 14.08.2026).
  function previewFehlt(file) {
    var frame = previewImg.parentNode;
    if (!frame) return;
    var typ = (file && file.type ? file.type.replace('image/', '').toUpperCase() : 'unbekannt');
    previewImg.style.display = 'none';
    var alt = frame.querySelector('[data-cc-preview-fallback]');
    if (!alt) {
      alt = document.createElement('p');
      alt.className = 'cc-up-preview__fallback';
      alt.setAttribute('data-cc-preview-fallback', '');
      frame.appendChild(alt);
    }
    alt.textContent = 'Dein Foto (' + typ + ') ist angekommen – dieses Format kann der Browser hier nur nicht anzeigen. Du kannst ganz normal weitermachen.';
    ccTrack('cc_up_preview_unsupported', { funnel_step: 'upload_photo', mime: (file && file.type) || '' });
  }

  function setFile(file) {
    if (!file || !file.type || file.type.indexOf('image/') !== 0) return;
    if (state.previewUrl) { try { URL.revokeObjectURL(state.previewUrl); } catch (e) {} }
    state.file = file;
    state.previewUrl = URL.createObjectURL(file);

    previewImg.style.display = '';
    var fb = previewImg.parentNode && previewImg.parentNode.querySelector('[data-cc-preview-fallback]');
    if (fb) fb.remove();

    // Blob-URL zuerst; scheitert sie, ueber FileReader als Daten-URL versuchen.
    previewImg.onerror = function () {
      previewImg.onerror = function () { previewFehlt(file); };
      try {
        var fr = new FileReader();
        fr.onload = function () { previewImg.src = fr.result; };
        fr.onerror = function () { previewFehlt(file); };
        fr.readAsDataURL(file);
      } catch (e) { previewFehlt(file); }
    };
    previewImg.src = state.previewUrl;
    dropEmpty.classList.add('cc-up-hidden');
    dropFilled.classList.remove('cc-up-hidden');
    var howto = $('[data-cc-howto]');
    if (howto) howto.classList.add('cc-up-hidden');
    ccTrack('cc_up_photo_added', { funnel_step: 'upload_photo' });
    updateSubmit();
  }
  // ---------- iOS: nur EIN Button ----------
  // Safari oeffnet bei accept="image/*" immer ein Blatt mit Mediathek + Kamera + Dateien.
  // Ein zusaetzlicher Kamera-Button ist dort also doppelt gemoppelt. Auf Android bleiben
  // beide, weil dort ohne capture haeufig direkt die Galerie aufgeht und wer noch kein Foto
  // hat sonst feststeckt (60+-Nutzertest 15.08.2026). Der Kamera-Button darf auf iOS NICHT
  // der uebrig bleibende sein: mit capture kommt man dort an vorhandene Fotos gar nicht mehr.
  // iPadOS meldet sich als "MacIntel" -> Touchpoint-Pruefung noetig.
  var istIOS = /iPad|iPhone|iPod/.test(navigator.userAgent || '') ||
               ((navigator.platform === 'MacIntel' || /Macintosh/.test(navigator.userAgent || '')) && navigator.maxTouchPoints > 1);
  if (istIOS) {
    root.classList.add('cc-up-ios');
    var camBtn = $('[data-cc-open-camera]');
    if (camBtn) camBtn.style.display = 'none';
    var galBtn = $('[data-cc-open-file]');
    var galLabel = $('[data-cc-galerie-label]');
    var iosText = root.getAttribute('data-cc-ios-label');
    if (galLabel && iosText) galLabel.textContent = iosText;
    if (galBtn) { galBtn.classList.remove('cc-up-secondary'); galBtn.classList.add('cc-up-bigbtn'); }
  }

  var camInput = $('[data-cc-file-camera]');
  $$('[data-cc-open-file]').forEach(function (b) { b.addEventListener('click', function () { fileInput.click(); }); });
  // Kamera-Weg: eigenes Feld mit capture. Ohne das landet man auf Android oft direkt in
  // der Galerie — wer noch kein Foto gemacht hat, steckt dort fest (15.08.2026).
  $$('[data-cc-open-camera]').forEach(function (b) {
    b.addEventListener('click', function () { (camInput || fileInput).click(); });
  });
  fileInput.addEventListener('change', function (e) { if (e.target.files && e.target.files[0]) setFile(e.target.files[0]); e.target.value = ''; });
  if (camInput) camInput.addEventListener('change', function (e) { if (e.target.files && e.target.files[0]) setFile(e.target.files[0]); e.target.value = ''; });
  var _el1 = $('[data-cc-remove-photo]'); if (_el1) _el1.addEventListener('click', function () {
    state.file = null;
    if (state.previewUrl) { try { URL.revokeObjectURL(state.previewUrl); } catch (e) {} }
    dropFilled.classList.add('cc-up-hidden');
    dropEmpty.classList.remove('cc-up-hidden');
    var howto2 = $('[data-cc-howto]');
    if (howto2) howto2.classList.remove('cc-up-hidden');
    updateSubmit();
  });
  ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); dragover.classList.remove('cc-up-hidden'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); dragover.classList.add('cc-up-hidden'); }); });
  drop.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer.files && e.dataTransfer.files[0]) setFile(e.dataTransfer.files[0]); });

  // ---------- Motiv-Picker ----------
  var drawer = $('[data-cc-drawer]');
  var motifPlus = $('[data-cc-motif-plus]');
  var motifSelected = $('[data-cc-motif-selected]');
  var selectedName = $('[data-cc-selected-name]');
  var selectedImg = $('[data-cc-selected-img]');
  function openPicker() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closePicker() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-cc-open-picker]').forEach(function (b) { b.addEventListener('click', openPicker); });
  $$('[data-cc-close-picker]').forEach(function (b) { b.addEventListener('click', closePicker); });

  // ---------- Schnellansicht (Quickview) ----------
  var quickModal = $('[data-cc-quick-modal]');
  var quickImg = $('[data-cc-quick-img]');
  var quickTitle = $('[data-cc-quick-title]');
  var quickSelectBtn = $('[data-cc-quick-select]');
  var quickCurrentTile = null;

  // Galerie in der Schnellansicht: dieselben Fotos wie auf der Muster-Produktseite,
  // geliefert über data-cc-quick-images (Varianten-Metafield custom.muster_set_images).
  // Punkte werden hier erzeugt, damit die Section kein zusätzliches Markup braucht.
  var quickDots = null;
  var quickShots = [];
  var quickIndex = 0;

  function quickShow(i) {
    if (!quickShots.length || !quickImg) return;
    quickIndex = (i + quickShots.length) % quickShots.length;
    quickImg.src = quickShots[quickIndex];
    if (quickDots) {
      Array.prototype.forEach.call(quickDots.children, function (d, n) {
        d.classList.toggle('is-active', n === quickIndex);
        d.setAttribute('aria-current', n === quickIndex ? 'true' : 'false');
      });
    }
  }

  function quickBuildDots() {
    if (!quickImg) return;
    if (!quickDots) {
      quickDots = document.createElement('div');
      quickDots.className = 'cc-up-quickdots';
      quickImg.parentNode.insertBefore(quickDots, quickImg.nextSibling);
      quickDots.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (b) quickShow(parseInt(b.getAttribute('data-i'), 10));
      });
      // Tippen/Klicken aufs Bild blättert weiter — auf dem Handy die naheliegendste Geste.
      quickImg.addEventListener('click', function () { if (quickShots.length > 1) quickShow(quickIndex + 1); });
    }
    quickDots.innerHTML = '';
    if (quickShots.length < 2) { quickDots.hidden = true; return; }
    quickDots.hidden = false;
    quickShots.forEach(function (_, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-i', n);
      b.setAttribute('aria-label', 'Bild ' + (n + 1) + ' von ' + quickShots.length);
      quickDots.appendChild(b);
    });
  }

  function openQuick(tile) {
    quickCurrentTile = tile;
    var trigger = tile.querySelector('[data-cc-quick]');
    var url = trigger.getAttribute('data-cc-quick');
    var name = tile.getAttribute('data-cc-motif');

    quickShots = [];
    try {
      var raw = trigger.getAttribute('data-cc-quick-images');
      if (raw) quickShots = JSON.parse(raw).filter(Boolean);
    } catch (err) { quickShots = []; }
    // Ohne gepflegte Metafield-Bilder bleibt es beim Varianten-Bild — nie eine leere Ansicht.
    if (!quickShots.length && url) quickShots = [url];

    if (quickImg) quickImg.alt = 'Motiv ' + name;
    quickBuildDots();
    quickShow(0);

    if (quickTitle) quickTitle.textContent = name;
    if (quickModal) { quickModal.classList.add('is-open'); }
    ccTrack('cc_up_quickview', { funnel_step: 'upload_motif', motiv: name });
  }
  function closeQuick() { if (quickModal) quickModal.classList.remove('is-open'); }
  if (quickModal) {
    quickModal.addEventListener('click', function (e) { if (e.target === quickModal) closeQuick(); });
    var qc = $('[data-cc-close-quick]'); if (qc) qc.addEventListener('click', closeQuick);
    if (quickSelectBtn) quickSelectBtn.addEventListener('click', function () {
      closeQuick();
      if (quickCurrentTile) quickCurrentTile.click();
    });
  }

  var tiles = $$('[data-cc-motif]');
  tiles.forEach(function (tile) {
    tile.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-cc-quick]')) { e.preventDefault(); openQuick(tile); return; }
      var motif = tile.getAttribute('data-cc-motif');
      var mimg = tile.getAttribute('data-cc-motif-img');
      state.motif = motif; state.motifImg = mimg;
      ccTrack('cc_up_motif_selected', { funnel_step: 'upload_motif', motiv: motif });
      tiles.forEach(function (t) { t.classList.remove('is-selected'); });
      tile.classList.add('is-selected');
      selectedName.textContent = motif;
      if (selectedImg && mimg) { selectedImg.src = mimg; selectedImg.alt = 'Motiv ' + motif; }
      motifPlus.classList.add('cc-up-hidden');
      motifSelected.classList.remove('cc-up-hidden');
      closePicker();
      updateSubmit();
    });
  });
  var search = $('[data-cc-search]');
  if (search) {
    search.addEventListener('input', function () {
      var q = search.value.toLowerCase().trim();
      tiles.forEach(function (t) {
        var name = (t.getAttribute('data-cc-motif') || '').toLowerCase();
        t.style.display = (!q || name.indexOf(q) >= 0) ? '' : 'none';
      });
    });
  }

  // ---------- E-Mail prefill (URL-Param -> sessionStorage-Fallback); Karte ausblenden wenn bekannt ----------
  var emailInput = $('[data-cc-email]');
  try {
    var qs = new URLSearchParams(location.search);
    var pe = qs.get('email');
    if (pe) {
      // E-Mail sofort aus der sichtbaren URL nehmen: sie landet sonst in Browser-Verlauf,
      // Lesezeichen, Referrern und Analytics — eine Adresse hat in einer URL nichts verloren.
      // Der Wert lebt danach nur noch im sessionStorage dieses Tabs.
      try {
        qs.delete('email');
        var rest = qs.toString();
        history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
      } catch (e) {}
    }
    if (!pe) { try { pe = sessionStorage.getItem('cc_funnel_email') || ''; } catch (e) {} }
    if (pe && emailInput) {
      emailInput.value = pe;
      try { sessionStorage.setItem('cc_funnel_email', pe); } catch (e) {}
      var emailCard = $('[data-cc-email-card]');
      if (emailCard && /.+@.+\..+/.test(pe)) emailCard.classList.add('cc-up-hidden');
    }
  } catch (e) {}

  // ---------- Help-Modal ----------
  // Das Hilfe-Fenster ist optional: Der Hilfe-Button wurde am 15.08.2026 aus der Seite
  // genommen (60+-Nutzertest, zu viele Klickpunkte). Ohne diese Pruefung warf die
  // Bindung hier "null.addEventListener" — und weil das die gesamte Initialisierung
  // abbrach, blieb der Submit-Button dauerhaft ausgegraut. Nie ungeprueft binden.
  var helpModal = $('[data-cc-help-modal]');
  var helpOpen = $('[data-cc-open-help]');
  if (helpModal && helpOpen) {
    helpOpen.addEventListener('click', function () { helpModal.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    $$('[data-cc-close-help]').forEach(function (b) { b.addEventListener('click', function () { helpModal.classList.remove('is-open'); document.body.style.overflow = ''; }); });
    helpModal.addEventListener('click', function (e) { if (e.target === helpModal) { helpModal.classList.remove('is-open'); document.body.style.overflow = ''; } });
  }

  // ---------- Submit ----------
  var submitBtn = $('[data-cc-submit]');
  var submitHint = $('[data-cc-submithint]');
  var uploadStatus = $('[data-cc-upload-status]');
  function updateSubmit() {
    var ready = !!(state.file && state.motif);
    submitBtn.disabled = !ready;
    if (!submitHint) return;
    submitHint.style.display = ready ? 'none' : '';
    if (ready) return;
    // Konkret sagen, was fehlt: wer mit dem Motiv anfaengt, sieht sonst nur den
    // Sammelsatz und sucht den Fehler bei sich (Alwin 24.08.2026).
    var d = submitHint.dataset;
    if (!state.file && !state.motif) submitHint.textContent = d.hintBeides || submitHint.textContent;
    else if (!state.file) submitHint.textContent = d.hintFoto || submitHint.textContent;
    else submitHint.textContent = d.hintMotiv || submitHint.textContent;
  }
  updateSubmit();

  // Foto clientseitig verkleinern (JPEG) -> Upload-Zeit sinkt bei schlechtem Netz massiv.
  // 2000px (nicht mehr 1200): mehr Detail-Substanz fuer die AI-Generierung; muss zu
  // KV_MAX_PHOTO im Endpoint passen.
  function shrinkPhoto(file) {
    return new Promise(function (resolve) {
      try {
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function () {
          try {
            var MAX = 2000;
            var w = img.naturalWidth, h = img.naturalHeight;
            if (Math.max(w, h) <= MAX) { URL.revokeObjectURL(url); return resolve(file); }
            var f = MAX / Math.max(w, h);
            var c = document.createElement('canvas');
            c.width = Math.round(w * f); c.height = Math.round(h * f);
            c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
            c.toBlob(function (blob) {
              URL.revokeObjectURL(url);
              resolve(blob ? new File([blob], 'kuechenfoto.jpg', { type: 'image/jpeg' }) : file);
            }, 'image/jpeg', 0.72);   // 0.85 ergab ~2,4 MB und damit mehrere Sekunden Upload auf Mobilfunk; 0.72 spart rund 30 % ohne sichtbaren Verlust fuer die Generierung (15.08.2026)
          } catch (err) { resolve(file); }
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      } catch (err) { resolve(file); }
    });
  }

  submitBtn.addEventListener('click', function () {
    if (!state.file || !state.motif) return;
    ccTrack('cc_up_submit', { funnel_step: 'upload_submit', motiv: state.motif });
    var label = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Wird gesendet…';
    var email = emailInput ? emailInput.value.trim() : '';

    function goToDanke(jobId) {
      var q = 'motiv=' + encodeURIComponent(state.motif);
      if (jobId) q += '&job=' + encodeURIComponent(jobId);
      window.location.href = dankeUrl + (dankeUrl.indexOf('?') >= 0 ? '&' : '?') + q;
    }

    if (!uploadEndpoint) {
      console.warn('[cc-upload] Kein Upload-Endpoint gesetzt — Demo-Weiterleitung ohne echten Foto-Upload.');
      goToDanke();
      return;
    }
    if (uploadStatus) { uploadStatus.classList.remove('cc-up-hidden', 'cc-up-status--error'); uploadStatus.textContent = 'Foto wird hochgeladen…'; }
    shrinkPhoto(state.file).then(function (photoFile) {
    var fd = new FormData();
    fd.append('photo', photoFile, photoFile.name || 'kuechenfoto.jpg');
    fd.append('email', email);
    fd.append('motiv', state.motif);
    return fetch(uploadEndpoint, { method: 'POST', body: fd })
      .then(function (r) {
        if (r.ok) return r.json().catch(function () { return {}; });
        // Der Endpoint begruendet Ablehnungen im Feld "detail" (Limit erreicht, kein Kuechenfoto
        // erkannt, …). Diese Begruendung MUSS beim Kunden ankommen: Am 15.08.2026 lief ein
        // Test in ein Limit, der Button sprang wortlos zurueck und die Seite wirkte kaputt.
        return r.json().catch(function () { return {}; }).then(function (j) {
          var e = new Error('upload-http-' + r.status);
          e.serverText = j && (j.detail || j.message);
          throw e;
        });
      })
      .then(function (data) { goToDanke(data && data.job_id); }); })
      .catch(function (err) {
        console.error('[cc-upload] Upload-Fehler:', err);
        submitBtn.disabled = false; submitBtn.textContent = label;
        if (uploadStatus) {
          uploadStatus.classList.remove('cc-up-hidden');
          uploadStatus.classList.add('cc-up-status--error');
          uploadStatus.textContent = (err && err.serverText)
            ? err.serverText
            : 'Der Upload hat nicht geklappt. Bitte prüfe Deine Verbindung und versuche es noch einmal.';
          try { uploadStatus.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        }
      });
  });
})();
